import { useBrandsAndProducts } from '~/react-query-hooks/knowledge-graph/useBrandsAndProducts';
import {
  useCompanyCompetitorWithThemes,
  useCompanyCountryExposure,
  useCompanyRegionExposure,
  useCompanyTheme,
} from '~/react-query-hooks/knowledge-graph/useKnowledgeGraph';

interface UseKnowledgeGraphDataParams {
  entityTag: string;
  isBrandsAndProductsEnabled: boolean;
}

export const useKnowledgeGraphData = ({
  entityTag,
  isBrandsAndProductsEnabled,
}: UseKnowledgeGraphDataParams) => {
  const { data: themeData, isFetching: isThemeFetching } = useCompanyTheme({
    entityTag,
  });

  const {
    data: brandsAndProductsData,
    isFetching: isBrandsAndProductsFetching,
  } = useBrandsAndProducts(entityTag, isBrandsAndProductsEnabled);

  const { data: competitorsData, isFetching: isCompetitorsFetching } =
    useCompanyCompetitorWithThemes({
      entityTag,
    });

  const { data: countryExposureData, isFetching: isCountryExposureFetching } =
    useCompanyCountryExposure({
      entityTag,
    });

  const { data: regionExposureData, isFetching: isRegionExposureFetching } =
    useCompanyRegionExposure({
      entityTag,
    });

  const hasThemeData = !!themeData?.length;
  const hasBrandsAndProductsData =
    isBrandsAndProductsEnabled && !!brandsAndProductsData?.length;
  const hasCompetitorsData = !!competitorsData?.length;
  const hasGeographicData =
    !!countryExposureData?.length || !!regionExposureData?.length;

  const isFetching =
    isThemeFetching ||
    isBrandsAndProductsFetching ||
    isCompetitorsFetching ||
    isCountryExposureFetching ||
    isRegionExposureFetching;

  return {
    hasThemeData,
    hasBrandsAndProductsData,
    hasCompetitorsData,
    hasGeographicData,
    isFetching,
  };
};
